import { RootState } from '@store/store.interface';

const getState = (state: RootState) => state.adminGlobalMessages;
export const adminGlobalMessageSelector = (state: RootState) => getState(state).data;
export const adminGlobalMessageIsLoadingSelector = (state: RootState) => getState(state).isLoading;
export const adminGlobalMessageErrorSelector = (state: RootState) => getState(state).error;
export const adminGlobalMessageIsDeletingSelector = (state: RootState) =>
  getState(state).isDeleting;
